import * as Icons from "@nova/component-icons"
import { BannerConfig, zIndex } from "@nova/constants"
import { useSWRNoRevalidate } from "@nova/swr"
import { ignoreBanner, selectIgnoredBanners } from "features/banners/slice"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { FunctionComponent, memo } from "react"

const useBanners = () => {
    const { data } = useSWRNoRevalidate("/api/banner", (key) =>
        fetch(key).then((res) => res.json())
    )
    return { banners: data as BannerConfig[] }
}

const BannerContainer: FunctionComponent = memo(() => {
    const ignored = useAppSelector(selectIgnoredBanners)
    const dispatch = useAppDispatch()
    const { banners = [] } = useBanners()

    const filteredBanners = banners.filter(
        (banner) => !ignored.map((ignoreBanner) => ignoreBanner.message).includes(banner.message)
    )

    return (
        <div
            style={{
                zIndex: zIndex.HighPriorityModal,
            }}
        >
            {filteredBanners.map((banner) => (
                <div
                    className="bg-gray-700 w-full flex justify-center items-center p-2 gap-3"
                    key={`${banner.message}:${banner.start}:${banner.end}`}
                >
                    <Icons.Error className="text-red-500" />
                    <h5 className="text-gray-0 max-w-lg">{banner.message}</h5>
                    <Icons.XClose
                        className="text-white-400 cursor-pointer"
                        onClick={() => dispatch(ignoreBanner(banner))}
                    />
                </div>
            ))}
        </div>
    )
})

BannerContainer.displayName = "BannerContainer"

export { BannerContainer }
